module.exports = __webpack_public_path__ + "static/media/Portrait-10014-original.f579169e.jpg";